import * as React from 'react';
import { useSelector } from 'react-redux';

import { BrandBanner, TBrandBannerLoadParams } from '../../components/BrandBanner';
import { SearchBlockAdLayout } from '../../components/SearchBlockAdLayout';
import { useBackgroundContext } from '../../components/countryside/BackgroundProvider';
import { selectPageSection } from '../../selectors/pageSection';
import { ESectionType } from '../../types/sectionType';

import styles from './BrandBannerContainer.css';

const COUNTRYSIDE_POST_VIEW_ANALYTICS = {
  place: 'filters' as const,
};

export interface IBrandBannerContainerProps {
  onLoad?(params: TBrandBannerLoadParams | null): void;
  onStub?(): void;
}

export const BrandBannerContainer: React.FC<IBrandBannerContainerProps> = ({ onLoad, onStub }) => {
  const section = useSelector(selectPageSection);
  const isCountryside = section === ESectionType.Countryside;

  const backgroundContext = useBackgroundContext();

  const handleLoad = React.useCallback(
    (params: TBrandBannerLoadParams | null) => {
      if (isCountryside) {
        backgroundContext.onAdfoxLoad({ bgImageUrl: params?.bgImageUrl, label: params?.label });

        return;
      }

      if (onLoad) {
        onLoad(params);
      }
    },
    [isCountryside, backgroundContext, onLoad],
  );

  const handleStub = React.useCallback(() => {
    if (isCountryside) {
      backgroundContext.onAdfoxStub();

      return;
    }

    if (onStub) {
      onStub();
    }
  }, [isCountryside, backgroundContext, onStub]);

  const postViewAnalyticsData = isCountryside
    ? COUNTRYSIDE_POST_VIEW_ANALYTICS
    : {
        place: 'filters_background' as const,
      };

  const banner = (
    <BrandBanner
      postViewAnalyticsData={postViewAnalyticsData}
      onLoad={handleLoad}
      onStub={handleStub}
      marqueeRedesignEnabled={!isCountryside && section === ESectionType.Index}
    />
  );

  if (isCountryside) {
    return <div className={styles['countryside-container']}>{banner}</div>;
  }

  return <SearchBlockAdLayout>{banner}</SearchBlockAdLayout>;
};
